import { cloneDeep } from 'lodash';

/**
 * Функция фильтрации списка объектов.
 * @param arr Входящий массив объектов.
 * @param fieldNames Поля объекта, по которому фильтровать.
 * @param matchText Текст который должен содержаться в поле fieldName
 * @returns Возвращает отфильтрованный массив объектов.
 */
export const filterListOfObjects = (arr, fieldNames, matchText) => {
    return matchText === ''
        ? cloneDeep(arr)
        : cloneDeep(arr).filter((item) => {
              let flag = false;
              fieldNames.forEach((name) => {
                  if (!flag) {
                      if (typeof item[name] !== 'object') {
                          flag = String(item[name]).toLowerCase().includes(matchText.toLowerCase());
                      } else {
                          flag = JSON.stringify(item[name]).toLowerCase().includes(matchText.toLowerCase());
                      }
                  }
              });
              return flag;
          });
};
